import axios from "axios";

export const fetchFlightData = async () => {
  const response = await axios.get("/FlightOperations/list");
  return response;
};
